import { cn } from "@/lib/utils";
import { Type } from "lucide-react";

import { useFontSize } from "@/components/FontSizeProvider";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Translator } from "components/i18n";

interface Props {
  className?: string;
}

export function FontSizeToggle({ className }: Props) {
  const { setFontSize } = useFontSize();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          id="font-size-toggle"
          variant="ghost"
          size="icon"
          className={cn(
            "text-muted-foreground hover:text-muted-foreground",
            className,
          )}
        >
          <Type className="!size-5" />
          <span className="sr-only">Toggle font size</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => setFontSize("small")}>
          <span className="text-xs">
            <Translator path="navigation.header.fontSize.small" />
          </span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setFontSize("medium")}>
          <span className="text-sm">
            <Translator path="navigation.header.fontSize.medium" />
          </span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setFontSize("large")}>
          <span className="text-base">
            <Translator path="navigation.header.fontSize.large" />
          </span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setFontSize("extra-large")}>
          <span className="text-lg">
            <Translator path="navigation.header.fontSize.extraLarge" />
          </span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
